var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_20017",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1{fill:#3F51B5}\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10915"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5180",
    d: "M192.055 106.62a1.2 1.2 0 0 0 .066.121c.022.033.055.066.077.1a.994.994 0 0 0 .11.1.37.37 0 0 0 .132.066.542.542 0 0 0 .143.044.674.674 0 0 0 .143.011.626.626 0 0 0 .143-.011.393.393 0 0 0 .121-.044h.01a.818.818 0 0 0 .132-.077.708.708 0 0 0 .1-.088l.011-.011a.6.6 0 0 0 .077-.1.344.344 0 0 0 .055-.11c0-.011 0-.011.011-.022a.713.713 0 0 0 .044-.143.934.934 0 0 0 0-.285 1.025 1.025 0 0 0-.044-.143.623.623 0 0 0-.132-.2l-.022-.022a.955.955 0 0 0-.11-.088c-.044-.022-.077-.044-.121-.066a.618.618 0 0 0-.132-.044.674.674 0 0 0-.143-.011.625.625 0 0 0-.143.011.618.618 0 0 0-.132.044h-.011a1.2 1.2 0 0 0-.121.066.96.96 0 0 0-.11.088.711.711 0 0 0-.088.1 1.2 1.2 0 0 0-.066.121.617.617 0 0 0-.044.132.675.675 0 0 0-.011.143.626.626 0 0 0 .011.143 1 1 0 0 0 .044.175z",
    className: "cls-1",
    transform: "translate(-186.735 -102.704)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5181",
    d: "M179.574 183.773h-.252v-2.687a.283.283 0 0 0-.285-.285h-1.152a.283.283 0 0 0-.285.285v.592a.283.283 0 0 0 .285.285h.23v1.821h-.23a.283.283 0 0 0-.285.285v.592a.283.283 0 0 0 .285.285h1.689a.283.283 0 0 0 .285-.285v-.592a.293.293 0 0 0-.285-.296z",
    className: "cls-1",
    transform: "translate(-172.73 -175.842)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5182",
    d: "M6 0a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm0 11.21A5.21 5.21 0 1 1 11.21 6 5.215 5.215 0 0 1 6 11.21z",
    className: "cls-1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLogo);
export default __webpack_public_path__ + "static/media/info_logo.7c9580eb23b459a402e875ce0621f98e.svg";
export { ForwardRef as ReactComponent };